import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Renderer2,
  HostListener,

} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '../../../../core/services';
import { AddEditFormGeneric } from '../../../../ui/generics';
import { IComplaint } from '../../interfaces/complaint.interface';
import { ComplaintsService } from '../../services/complaints.service';
import { ComplaintServiceErrorResolverService } from '../../services/error-resolvers/complaint-service-error-resolver.service';
import { StoresService } from 'src/app/pages/stores/core/services/StoresService';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { UsersService } from 'src/app/pages/users/core/services/UsersService';
import { Observable } from 'rxjs';
import { ISimpleListItem } from 'src/app/core/interfaces/ISimpleListItem';
import { ComplaintsStatuses, ComplaintsStatusesList, IComplaintStatus, getStatusLabel } from '../../enums/statuses.enum';
import { FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ArticlesVariantsService } from 'src/app/pages/articles/core/ArticlesVariantsService';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { ToolsService } from '../../../../core/services/ToolsService';
import { UploadDocumentTypes } from '../../../../core/enums';
import { debug } from 'console';
@Component({
    selector: 'app-add-edit-form',
    templateUrl: './add-edit-form.component.html',
    styleUrls: ['./add-edit-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddEditFormComponent extends AddEditFormGeneric<IComplaint> implements OnInit {

  public storesList$: Observable<ISimpleListItem[]>;
  public storesList: ISimpleListItem[] = [];
  public targetStoresList: ISimpleListItem[] = [];
  public complaintsStatuses: IComplaintStatus[] = ComplaintsStatusesList;
  public ComplaintsStatuses = ComplaintsStatuses;
  public editedRowId: number;
  public productsData: any[] = [];
  public isArticlesLoading = false;
  public searchArticleChange$ = new Subject();

  public articlesList: ISimpleListItem[] = [];
  public editRow: number;
  public productFormList: FormArray;
  searchStoresChange$ = new Subject();
  searchUsersChange$ = new Subject();
  searchHandlerChange$ = new Subject();
  public additionalProducts: ISimpleListItem[] = [];
  public isAdditionalProductsModalVisible = false;
  public readonly environment = environment;
  public readonly uploadDocumentTypes = UploadDocumentTypes;
  public isFileUploading = false;
  public usersList: ISimpleListItem[] = [];
  public isUsersLoading = false;
  public isStoresLoading = false;


  constructor(
    public readonly toolsService: ToolsService,
    protected _fb: FormBuilder,
    protected _complaintsService: ComplaintsService,
    protected _notifyService: NotificationService,
    protected _errorResolver: ComplaintServiceErrorResolverService,
    protected _storesService: StoresService,
    protected _usersService: UsersService,
    protected _cdr: ChangeDetectorRef,
    protected _renderer: Renderer2,
    protected articleVariantsService: ArticlesVariantsService
  ) {
    super(_fb, _complaintsService, _notifyService, _errorResolver);
  }

  public ngOnInit(): void {
    const obj = {
      dateOfReceipt: [new Date(), Validators.required],
      status: [ComplaintsStatuses.InProgress, Validators.required],
      placeOfReceipt: [null, Validators.required],
      receivedBy: [null, Validators.required],
      customerName: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.email]],
      shippingAddress: ['', Validators.required],
      remarks: [''],
      deliveryNote: [''],
      documentKeys: [[]],
      products: this._fb.array([])
    };
    this.form = this._fb.group(obj);

    this.productFormList = this.form.get('products') as FormArray;

    super.ngOnInit();


    const getStores = () =>
      this._storesService.getSimple();

    const getArticles = (name: string) =>
      this.articleVariantsService.getSimpleList(name);

    const getUsers = (name: string) =>
      this._usersService.getSimpleList(name);

    const usersOptionList$: Observable<ISimpleListItem[]> = this.searchUsersChange$
      .asObservable()
      .pipe(debounceTime(500))
      .pipe(switchMap(getUsers));
    usersOptionList$.subscribe(data => {
      this.usersList = data;
      this.isUsersLoading = false;
      this._cdr.detectChanges();
    });


    const storesOptionList$: Observable<ISimpleListItem[]> = this.searchStoresChange$
      .asObservable()
      .pipe(debounceTime(500))
      .pipe(switchMap(getStores));
    storesOptionList$.subscribe(data => {
      this.storesList = data;
      this._cdr.detectChanges();
    });

    const articlesOptionList$: Observable<ISimpleListItem[]> = this.searchArticleChange$
      .asObservable()
      .pipe(debounceTime(500))
      .pipe(switchMap(getArticles));
    articlesOptionList$.subscribe(data => {
      this.articlesList = data;
      this.isArticlesLoading = false;
      this._cdr.detectChanges();
    });
  }

  loadForm(): void {
    if (this.editObject) {
      this.loading = true;
      this.isEdit = true;
      this._formService.getById(this.editObject['id'].toString()).subscribe(value => {
        this._editObject = value;
        this.beforeLoadForm();
        this.form.patchValue(this.editObject);
        this.afterLoadForm();
        this.loading = false;
      });
    }
  }

  getStatusLabel(status: string): string {
    return getStatusLabel(status as ComplaintsStatuses);
  }

  @HostListener('window:click', ['$event.target'])
  public onClickAnywhere(target: HTMLElement): void {
    const fId = this._renderer.selectRootElement('.cdk-global-overlay-wrapper > div', true).getAttribute('id');
    if (
      target.closest('.editable-row') === null &&
      target.closest('#add-product-row') === null &&
      target.closest('.cdk-overlay-pane')?.getAttribute('id') === fId
    ) {
      this.editedRowId = null;
      this._cdr.detectChanges();
    }
  }

  addProduct(isNew = true) {
    this.productFormList.push(this.createProductItem(isNew));
    if (isNew) {
      this.editRow = this.productFormList.length - 1;
    }
  }

  createProductItem(isNew: boolean): FormGroup {
    const obj = {
      id: -1,
      productName: ['', Validators.required],
      articleId: null,
      articleVariantId: null,
      product: [null],
      articleNumber: "",
      defectDescription: [''],
      isNew
    };

    return  this._fb.group(obj);
  }

  deleteRow(id: number): void {
    this.productFormList.removeAt(id);

  }

  productChange(event: any): void {
    if (event) {
      const article = this.articlesList.find(x => x.id === event);
      const index = this.editRow;
      const control = (this.form.get('products') as FormArray).at(index);
      const articleNumber = article.value.split('-')[0].trim();
      const productName = article.value.split('-').slice(1).join('-').trim();
      control.patchValue({
        productName: productName,
        articleNumber: articleNumber,
        articleId: article.additionalParameters.articleId,
        articleVariantId: article.additionalParameters.articleVariantId,
        isNew: false,
        product: null
      });
    }
  }

  beforeLoadForm() {
    if (this.editObject.products) {
      this.editObject.products.forEach(() => this.addProduct(false));
    }

    if (this.editObject.placeOfReceipt) {
      this.searchStoresChange$.next(this.editObject.placeOfReceipt.name);
    }

    if (this.editObject.receivedBy) {
      this.searchUsersChange$.next(this.editObject.receivedBy.fullName);
    }

  }


  onArticleSearch(value: string): void {
    this.isArticlesLoading = true;
    this.searchArticleChange$.next(value);
  }


  startEdit(id: number): void {
    this.editRow = id;
  }

  onSearchStores(value: string): void {
    this.isStoresLoading = true;
    this.searchStoresChange$.next(value);
  }

  onSearchUsers(value: string): void {
    this.isUsersLoading = true;
    this.searchUsersChange$.next(value);
  }

  public handleChange(info: NzUploadChangeParam): void {
    this.isFileUploading = true;

    switch (info.type) {
      case 'start': {
        this.isFileUploading = true;
        this._notifyService.pushInfo('Infos', 'Dokument wird hochgeladen, das kann einige Zeit dauern');
        break;
      }

      case 'success': {
        this._notifyService.pushSuccess('Erfolg', 'Dokument wurde hochgeladen');
        this.isFileUploading = false;
        this.form.get('documentKeys')
          .patchValue([...this.form.get('documentKeys').value, info.file.response['key']]);
        break;
      }
    }
  }

  public removeDoc(doc: string): void {
    this.form.get('documentKeys')
      .patchValue(this.form.get('documentKeys').value.filter(x => x !== doc));
  }

}
